import React, { useEffect, useState } from 'react';
import API from '../services/api';

function TherapistDebtPage() {
  const [debtRecords, setDebtRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Track which record is being edited and its draft value
  const [editingId, setEditingId] = useState(null);
  const [editDraft, setEditDraft] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchDebtRecords();
  }, []);

  const fetchDebtRecords = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await API.get('/therapist/debt-records');
      setDebtRecords(res.data);
    } catch (err) {
      console.error('Error fetching debt records:', err);
      setError('Failed to load debt records.');
    } finally {
      setLoading(false);
    }
  };

  const startEditing = (record) => {
    setEditingId(record.id);
    setEditDraft(record.therapist_notes || '');
  };

  const cancelEditing = () => {
    setEditingId(null);
    setEditDraft('');
  };

  const saveNotes = async (recordId) => {
    setSaving(true);
    try {
      await API.patch('/therapist/debt-records/' + recordId + '/notes', {
        therapistNotes: editDraft
      });
      // Update local state so we don't need a full re-fetch
      setDebtRecords(prev =>
        prev.map(r =>
          r.id === recordId ? { ...r, therapist_notes: editDraft } : r
        )
      );
      setEditingId(null);
      setEditDraft('');
    } catch (err) {
      console.error('Error saving therapist notes:', err);
      alert('Error saving notes. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2 style={{ marginBottom: '1rem' }}>Debt Sessions</h2>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {(!loading && debtRecords.length === 0) ? (
        <p>No debt sessions found.</p>
      ) : (
        <table
          border="1"
          cellPadding="5"
          style={{ borderCollapse: 'collapse', width: '100%' }}
        >
          <thead style={{ background: '#eee' }}>
            <tr>
              <th>Client</th>
              <th>Date</th>
              <th>Service</th>
              <th>Billed</th>
              <th>Collected</th>
              <th>Therapist Notes</th>
              <th>Admin Notes</th>
            </tr>
          </thead>
          <tbody>
            {debtRecords.map((record) => (
              <tr key={record.id}>
                <td>{record.client_name}</td>
                <td>{new Date(record.session_date).toLocaleDateString()}</td>
                <td>{record.service_type}</td>
                <td>${record.billed_amount}</td>
                <td>${record.collected_amount || 0}</td>
                <td style={{ minWidth: '200px' }}>
                  {editingId === record.id ? (
                    <div>
                      <textarea
                        value={editDraft}
                        onChange={(e) => setEditDraft(e.target.value)}
                        rows={3}
                        style={{
                          width: '100%',
                          padding: '6px 8px',
                          fontSize: '13px',
                          border: '1px solid #91d5ff',
                          borderRadius: '4px',
                          resize: 'vertical',
                          boxSizing: 'border-box'
                        }}
                        autoFocus
                      />
                      <div style={{ marginTop: '6px', display: 'flex', gap: '6px' }}>
                        <button
                          onClick={() => saveNotes(record.id)}
                          disabled={saving}
                          style={{
                            backgroundColor: '#1890ff',
                            color: 'white',
                            border: 'none',
                            padding: '4px 12px',
                            borderRadius: '4px',
                            cursor: saving ? 'not-allowed' : 'pointer',
                            fontSize: '12px',
                            opacity: saving ? 0.6 : 1
                          }}
                        >
                          {saving ? 'Saving...' : 'Save'}
                        </button>
                        <button
                          onClick={cancelEditing}
                          disabled={saving}
                          style={{
                            backgroundColor: '#fff',
                            color: '#333',
                            border: '1px solid #ddd',
                            padding: '4px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '12px'
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      onClick={() => startEditing(record)}
                      style={{
                        cursor: 'pointer',
                        padding: '4px',
                        borderRadius: '4px',
                        minHeight: '24px',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f5ff'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      title="Click to edit notes"
                    >
                      {record.therapist_notes ? (
                        <span>{record.therapist_notes}</span>
                      ) : (
                        <span style={{ color: '#bbb', fontStyle: 'italic' }}>Click to add notes...</span>
                      )}
                    </div>
                  )}
                </td>
                <td>{record.admin_notes || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TherapistDebtPage;
